import './index.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

import { SpinnerIcon, XCircleIcon } from '@phosphor-icons/react';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Amplify } from 'aws-amplify';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'sonner';

import { TooltipProvider } from './components/ui/tooltip';
import { AppRouter, ThemeProvider } from './modules/common';
import ErrorComponent from './modules/common/components/error-component';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

Sentry.init({
  dsn: 'https://bbbe6a7c1676fb24f74b105f1f28805c@o4509085475274752.ingest.us.sentry.io/4509122200403968',
});

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_AWS_COGNITO_USER_CLIENT_ID,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <Suspense fallback={<SpinnerIcon className="animate-spin" />}>
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <ErrorBoundary
        FallbackComponent={({ error }) => (
          <ErrorComponent message={error.message} />
        )}
        key={location.pathname}
      >
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <AppRouter />
          </TooltipProvider>
        </QueryClientProvider>
        <Toaster
          position="bottom-right"
          offset={20}
          theme="dark"
          richColors
          icons={{
            error: <XCircleIcon size={24} />,
          }}
        />
      </ErrorBoundary>
    </ThemeProvider>
  </Suspense>
);
